export function AccessDenied() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="bg-red-500/10 p-4 rounded-full mb-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-red-500"
        >
          <path d="m21 16-4-4"></path>
          <path d="m17 16 4-4"></path>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        </svg>
      </div>
      <h2 className="text-2xl font-semibold text-black mb-2">Access Denied</h2>
      <p className="text-zinc-500 mb-8 max-w-md">
        You do not have the required permissions to view this page. If you
        believe this is a mistake, please contact your administrator.
      </p>
    </div>
  );
}
